<template>
    <div class="analyze">
        <el-row>
            <el-col :span="3">
                <span class="h3">{{$t('shu_ju_dao_chu')}}</span>
            </el-col>
        </el-row>
        <export  class="analyze-data"></export>
        <!--<div class="analyze-data">-->
            <!--<el-tabs v-model="activeName">-->
                <!--<el-tab-pane label="异常分析" name="fault">-->
                    <!--<fault v-if="activeName=='fault'"></fault>-->
                <!--</el-tab-pane>-->
                <!--<el-tab-pane label="保养分析" name="maintain">-->
                    <!--<maintain v-if="activeName=='maintain'"></maintain>-->
                <!--</el-tab-pane>-->
                <!--<el-tab-pane label="数据导出" name="export">-->
                    <!--<export v-if="activeName =='export'"></export>-->
                <!--</el-tab-pane>-->
            <!--</el-tabs>-->
        <!--</div>-->
    </div>

</template>

<script>
    import Fault from './fault.vue'
    import Maintain from './maintain.vue'
    import Export from './export.vue'
    export default {
        name: '',
        components: {
            Fault,
            Maintain,
            Export
        },
        mounted: function () {
        },
        data: function () {
            return {
                activeName: 'fault'
            }
        },
        filters: {},
        methods: {},
    }
</script>

<style lang="scss">
    .analyze {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;

        .analyze-data {
            margin-top: $padding;
            flex: 1;
        }

    }

</style>
